import { render, staticRenderFns } from "./OwnersMaintenanceRequestDetail.vue?vue&type=template&id=28bdcd89&"
import script from "./OwnersMaintenanceRequestDetail.vue?vue&type=script&lang=js&"
export * from "./OwnersMaintenanceRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./OwnersMaintenanceRequestDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports